import { getRuleFiltersConfigBySection } from '@kw/quokka-ui';
import { FiltersAndTable } from '../FiltersAndTable';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
}

export const Permissions = ({ ruleSummaries, analysisId }: IProps) => {
  const filtersConfig = getRuleFiltersConfigBySection({ ruleSummaries, section: 'permission' });
  return <FiltersAndTable filtersConfig={filtersConfig} analysisId={analysisId} data={ruleSummaries} />;
};
